/**
 * The props a registry-driven text box takes from its field's text kind.
 * A name kind gives the box name case (which also turns off the phone's
 * own sentence capital). A dictionary-scope kind turns that capital off
 * too, so a typed "prn" stays lower case and can read PRN, and so does a
 * code (a member ID, an Rx BIN), which is kept exactly as typed. Every
 * other kind leaves the box as the browser has it.
 */

import type { TextKind } from '@/lib/noteVocabulary';
import type { NameCaseKind } from '@/lib/valueCase';

export interface TextBoxProps {
  nameCase?: NameCaseKind;
  autoCapitalize?: 'none';
}

const NAME_KINDS: ReadonlySet<string> = new Set(['person', 'place', 'role', 'relationship', 'carrier']);
const DICTIONARY_SCOPES: ReadonlySet<string> = new Set([
  'medication',
  'medication_reason',
  'diagnosis',
  'appointment_purpose',
  'allergy',
  'code',
]);

export function textBoxProps(kind: TextKind | undefined): TextBoxProps {
  if (kind === undefined) return {};
  if (NAME_KINDS.has(kind)) return { nameCase: kind as NameCaseKind };
  if (DICTIONARY_SCOPES.has(kind)) return { autoCapitalize: 'none' };
  return {};
}
